
export default function Footer() {
  return (
    <footer className="relative bg-gray-950 py-16 px-6 lg:px-12 overflow-hidden">
      {/* Subtle gradient top border */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-pink/30 to-transparent"></div>

      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/1a6cfeb3-290b-48a8-a668-691063b6ae31.png"
              alt="Brain Wash"
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm text-white/40 leading-relaxed max-w-xs">
              A cognitive performance and nervous system reconditioning platform. Not therapy. Not meditation. Real change.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-sm font-semibold text-white/60 uppercase tracking-widest mb-5">
              <a href="#system" className="hover:text-white transition-colors cursor-pointer">
                Explore
              </a>
            </h4>
            <div className="space-y-3">
              <a
                href="#system"
                rel="nofollow"
                className="block text-sm text-white/40 hover:text-brand-pink transition-colors cursor-pointer"
              >
                How It Works
              </a>
              <a
                href="#features"
                rel="nofollow"
                className="block text-sm text-white/40 hover:text-brand-pink transition-colors cursor-pointer"
              >
                Features
              </a>
              <a
                href="#results"
                rel="nofollow"
                className="block text-sm text-white/40 hover:text-brand-pink transition-colors cursor-pointer"
              >
                Results
              </a>
              <a
                href="#cta"
                rel="nofollow"
                className="block text-sm text-white/40 hover:text-brand-pink transition-colors cursor-pointer"
              >
                Get Started
              </a>
            </div>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-sm font-semibold text-white/60 uppercase tracking-widest mb-5">
              <a href="#" className="hover:text-white transition-colors cursor-pointer">
                Connect
              </a>
            </h4>
            <div className="space-y-3">
              <a
                href="#"
                rel="nofollow"
                className="flex items-center gap-2 text-sm text-white/40 hover:text-brand-teal transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-line text-base"></i> Twitter
              </a>
              <a
                href="#"
                rel="nofollow"
                className="flex items-center gap-2 text-sm text-white/40 hover:text-brand-teal transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-base"></i> Instagram
              </a>
              <a
                href="#"
                rel="nofollow"
                className="flex items-center gap-2 text-sm text-white/40 hover:text-brand-teal transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-box-line text-base"></i> LinkedIn
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/25">
            &copy; 2025 Brain Wash. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            rel="nofollow"
            className="text-xs text-white/25 hover:text-white/40 transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
